<template>
    
        <div class="page__content" >

        <HeaderBody/>

        <div class="activity" >
                    <div class="activity__container">
                        
                        <div class="activity__sorting">

                            <div class="activity__tags tablet-hide">
                                <router-link class="activity__link active" :to="{name: 'borrow'}" id="rStaking11">Borrow crypto</router-link>
                                <router-link class="activity__link " :to="{name: 'borrow-history'}" id="rStaking12">History & repayments</router-link>
                            </div>

                            <div class="activity__tags tablet-show">
                                <router-link class="activity__link active" :to="{name: 'borrow'}" id="rStaking21"  style="padding: 10px 15px 10px 15px;">Borrow crypto</router-link>
                                <router-link class="activity__link"  :to="{name: 'borrow-history'}" id="rStaking22" style="padding: 10px 15px 10px 15px;">History & repayments</router-link>
                                
                            </div>
                            
                        </div>
                        
                        
                    </div>
                    
        </div>

        <div class="promotions ffo">
                    <div class="promotions__wrapper" style="margin-top: -40px; margin-bottom: 0px;">

                        <!-- <div class="search" style="margin-top: 20px; margin-bottom: 0px;">
                            <div class="search__container" >
                                <div class="search__wrap">
                                    <div class="search__title h3" style="color:#ffffff"> Borrow Crypto </div>
                                    <div class="search__info" style="margin-bottom: 5px;"> Accelerate your ambitions with a crypto Credit Line. Borrow one type of crypto asset using another one as collateral.</div>
                                    
                                </div>

                                
                                
                            </div>
                        </div> -->
                        
                        

                        <div class="page__row" style="width: 100%; display: flex; justify-content: center; align-items: flex-start;">

                            <div class="page__co" style="width: 600px;">
                                        <div class="details">
                                            <div class="details__container">
                                                
                                                <!-- LOAN AMOUNT -->
                                                <div class="exchange__top" style="margin-top: 0px; z-index: 3; width: 100%;">
                                                    
                                                    <div class="exchange__cell">
                                                        <div class="exchange__info" style="margin-bottom: 20px;">Loan amount</div>
                                                        <div class="exchange__price">
                                                            <input class="field__input js-field-input" type="number" style="color: #ffffff; border-style: none !important;  padding: 20px !important;" placeholder="0.00" v-model="loanAmount" @input="getColAmount">
                                                        </div>

                                                        <div class="exchange__company xxm1"  >
                                                            <div class="exchange__head twooo" style="z-index:1; margin-top: 20px;" >
                                                                <div class="exchange__log">
                                                                    <img :src="loanImage" alt="" style="width: 30px; margin-right: 5px;">
                                                                </div>
                                                                <div class="exchange__details" >
                                                                    <div class="exchange__currency" style="font-size: 12px;">{{ loanSymbol }}</div>
                                                                    <div class="exchange__info">{{ loanCoin }}</div>
                                                                </div>
                                                                
                                                            </div>
                                                            
                                                        </div>

                                                    </div>

                                                    
                                                </div>

                                                <!-- COLLATERAL -->
                                                <div class="exchange__top" style="margin-top: 0px; z-index: 3; width: 100%;">
                                                    
                                                    <div class="exchange__cell">
                                                        <div class="exchange__info" style="margin-bottom: 20px;">Collateral amount</div>
                                                        <div class="exchange__price">
                                                            <input class="field__input js-field-input" type="number" style="color: #ffffff; border-style: none !important; width: 100%; " placeholder="0.00" disabled v-model="colAmount">
                                                        </div>
                                                    </div>

                                            
                                                </div>

                                                <div class="exchange__company"   style="position: relative; ">
                                                            <div class="exchange__head twooo xxm2"  ref="block2" @click="openBlock2">
                                                                <div class="exchange__log">
                                                                    <img :src="colImage" alt="" style="width: 30px; margin-right: 5px;" >
                                                                </div>
                                                                <div class="exchange__details" >
                                                                    <div class="exchange__currency" style="font-size: 12px;">{{ colSymbol }}</div>
                                                                    <div class="exchange__info">{{ colCoin }}</div>
                                                                </div>
                                                                <div class="exchange__arrow">
                                                                    <img src="@/assets/dashAssets/img/sArrow.png" alt="" style="width: 15px; margin-left: 5px;">
                                                                </div>
                                                            </div>

                                                            
                                                </div>

                                                <!-- <div class="popup__field" style="margin-bottom: 50px;">
                                                    <div class="popup__label">Duration</div>
                                                    <div class="popup__wrap">
                                                        <select v-model="duration"  style="color:#ffffff; padding:20px 15px 20px 15px; border-radius: 10px; background-color: #242731; width: 100%;">
                                                            <option value="30">30 days</option>
                                                            
                                                            <option value="90" >90 days</option>
                                                            <option value="180" >180 days</option>
                                                            
                                                        </select>
                                                    </div>
                                                </div> -->
                                                
                                            
                                                <button @click="borrow" class="details__btn btn btn_blue btn_wide btn_big" style="z-index: 2" >Borrow</button>

                                            


                                            </div>
                                        </div>
                            </div>

                            <div class="page__co mm-none" style="width: 400px; margin-left: 20px; ">
                                        <div class="details">
                                            <div class="details__container" >
                                                
                                                
                                                <h4 style="color: #ffffff; ">Summary</h4>

                                                <div style="display: flex; justify-content: space-between; align-items: center; width: 100%; margin-top: 50px;">

                                                    <p>Loan amount</p>
                                                    <p>{{ loanAmount }} {{ loanSymbol }}</p>

                                                </div>

                                                <div style="display: flex; justify-content: space-between; align-items: center; width: 100%; margin-top: 20px;">

                                                    <p>Collateral</p>
                                                    <p>{{ colAmount }} {{ colSymbol }}</p>

                                                </div>

                                                

                                                <div style="display: flex; justify-content: space-between; align-items: center; width: 100%; margin-top: 20px;">

                                                    <p>Interest</p>
                                                    <p>{{interest}}%</p>

                                                </div>

                                                <div style="display: flex; justify-content: space-between; align-items: center; width: 100%; margin-top: 20px;">

                                                    <p>Repayment</p>
                                                    <p>{{ repayment }} {{ loanSymbol }}</p>

                                                </div>

                                                <div style="display: flex; justify-content: space-between; align-items: center; width: 100%; margin-top: 20px; margin-bottom: 50px;">

                                                    <p>Term</p>
                                                    <p>1 year</p>

                                                </div>
                                            


                                            </div>
                                        </div>
                            </div>

                        </div>

                        <div class="page__col dd-none" style=" margin-top: 0px; ">
                                        <div class="details" style="width: 100%;">
                                            <div class="details__container" >
                                                
                                                
                                                <h4 style="color: #ffffff; ">Summary</h4>

                                                <div style="display: flex; justify-content: space-between; align-items: center; width: 100%; margin-top: 50px;">

                                                    <p>Loan amount</p>
                                                    <p>{{ loanAmount }} {{ loanSymbol }}</p>

                                                </div>

                                                <div style="display: flex; justify-content: space-between; align-items: center; width: 100%; margin-top: 20px;">

                                                    <p>Collateral</p>
                                                    <p>{{ colAmount }} {{ colSymbol }}</p>

                                                </div>

                                                <div style="display: flex; justify-content: space-between; align-items: center; width: 100%; margin-top: 20px;">

                                                    <p>Interest</p>
                                                    <p>{{interest}}%</p>

                                                </div>

                                                <div style="display: flex; justify-content: space-between; align-items: center; width: 100%; margin-top: 20px;">

                                                    <p>Repayment</p>
                                                    <p>{{ repayment }} {{ loanSymbol }}</p>

                                                </div>

                                                <div style="display: flex; justify-content: space-between; align-items: center; width: 100%; margin-top: 20px; margin-bottom: 50px;">

                                                    <p>Term</p>
                                                    <p>1 year</p>

                                                </div>
                                            


                                            </div>
                                        </div>
                            </div>

                        
                    </div>
        </div>

    </div>
    

        <div style=" display: flex; justify-content: center; align-items: center; z-index: 9999;  " class="loadingModalBg" ref="loadingModal">

            <div class="popup__container" style="width: 300px; background-color:#1F2128; border-radius: 30px; padding: 20px;">
                        
                <div class="popup__box">

                    <div class="popup__fieldset" >
                        
                        <div class="popup__row" style="width: 100%; display: flex; flex-direction: column; justify-content: center; align-items: center;">
                            
                            <img src="@/assets/dashAssets/img/loading.gif" alt="">

                            <p style="text-align: center; color: #ffffff;">{{loadingText}}</p>
                            
                        </div>

                        
                        
                        
                    </div>
                    

                    

                    
                </div>
                
            </div>

        </div>

        <div style=" display: flex; justify-content: center; align-items: center; z-index: 9999;  " class="loadingModalBg" ref="successModal">

        <div class="popup__container" style="width: 300px; background-color:#1F2128; border-radius: 30px; padding: 20px;">
                    
            <div class="popup__box">

                <div class="popup__fieldset" >
                    
                    <div class="popup__row" style="width: 100%; display: flex; flex-direction: column; justify-content: center; align-items: center;">
                        
                        <img src="@/assets/dashAssets/img/done.png" alt="" style="width: 100px; margin: 10px;">

                        <p style="text-align: center; margin-bottom: 40px; color: #ffffff;">{{successText}}</p>

                        <button class="operations__btn btn btn_blue" @click="closeS">Okay</button>
                        
                    </div>

                    
                    
                    
                    
                </div>
                

                

                
            </div>
            
        </div>

        </div>

        <div style=" display: flex; justify-content: center; align-items: center; z-index: 9999;  " class="loadingModalBg" ref="successModal2">

        <div class="popup__container" style="width: 300px; background-color:#1F2128; border-radius: 30px; padding: 20px;">
                    
            <div class="popup__box">

                <div class="popup__fieldset" >
                    
                    <div class="popup__row" style="width: 100%; display: flex; flex-direction: column; justify-content: center; align-items: center;">
                        
                        <img src="@/assets/dashAssets/img/done.png" alt="" style="width: 100px; margin: 10px;">

                        <p style="text-align: center; margin-bottom: 40px; color: #ffffff;">{{successText2}}</p>

                        <button class="operations__btn btn btn_blue" @click="closeS2">Okay</button>
                        
                    </div>

                    
                    
                    
                    
                </div>
                

                

                
            </div>
            
        </div>

        </div>

        <div style=" display: flex; justify-content: center; align-items: center; z-index: 9999;  " class="loadingModalBg" ref="errorModal">

        <div class="popup__container" style="width: 300px; background-color:#1F2128; border-radius: 30px; padding: 20px;">
                    
            <div class="popup__box">

                <div class="popup__fieldset" >
                    
                    <div class="popup__row" style="width: 100%; display: flex; flex-direction: column; justify-content: center; align-items: center;">
                        
                        <img src="@/assets/dashAssets/img/error.png" alt="" style="width: 100px; margin: 10px;">

                        <p style="text-align: center; margin-bottom: 40px; color: #ffffff;">{{errorText}}</p>

                        <button class="operations__btn btn btn_blue" @click="closeE">Okay</button>
                        
                    </div>

                    
                    
                    
                </div>
                

                

                
            </div>
            
        </div>

        </div>

        <div style=" display: flex; justify-content: center; align-items: center; z-index: 9999;  " class="loadingModalBg" ref="coinModal">

            <div class="popup__container" style="width: 400px; height: 500px; overflow-y: scroll; background-color:#1F2128; border-radius: 30px; padding: 20px;">
                        
                <div class="popup__box">

                    <div class="popup__fieldset" >
                        
                        <div class="popup__row" style="width: 100%; display: flex; flex-direction: column; justify-content: center; align-items: center;">
                            
                            <h5 style="color: #da4bfb; margin-top: 20px; margin-bottom: 20px;">Select collateral</h5>
                            
                            <a class="exchange__item" style="width: 100%; " v-for="coin in coinList" :key="coin.symbol" @click="updateBlock(coin.name, coin.symbol, coin.image, coin.balance, coin.balanceUsd, coin.price, coin.walletId)">
                                                                        <div class="exchange__logo">
                                                                            <img :src="coin.image" alt="" style=" border-radius: 50%;">
                                                                        </div>
                                                                        <div class="exchange__details">
                                                                            <div class="exchange__currency">{{coin.symbol}}</div>
                                                                            <div class="exchange__info">{{coin.name}}</div>
                                                                        </div>
                                                                    </a>
                            
                            
                        </div>

                        
                        
                        
                    </div>
                    

                    

                    
                </div>
                
            </div>

        </div>

</template>

<style scoped>

    ::placeholder {
        color: #c3c3c3;
        opacity: 1; /* Firefox */
    }

    ::-ms-input-placeholder { /* Edge 12 -18 */
        color: #c3c3c3;
    }

    .dd-none{
        display: none;
    }

    .xxm1{
        position: absolute; top: 70px; right: 30px;
    }

    .xxm2{
    
        z-index:1; margin-top: 20px; bottom: 105px; right: 50px; position: absolute;

    }

    .ffo{
        margin-top: -50px;
    }

    @media only screen and (max-width: 768px){

        .mm-none{
            display: none;
        }

        .dd-none{
            display: flex;
        }

        .xxm1{
            position: absolute; top: 60px; right: 30px;
        }

        .xxm2{
        
            z-index:1; margin-top: 20px; bottom: 70px; right: 40px; position: absolute;

        }

        .ffo{
            margin-top: 0px;
        }

    }

</style>

<script>

    import { doc, addDoc, collection, query, where, getDocs, getDoc, serverTimestamp, updateDoc, increment, orderBy } from "firebase/firestore"; 
    import { db } from '@/firebase';
    import axios from 'axios';
    import HeaderBody from '@/components/dashboard/HeaderBody.vue';
    import coinIdMap from '../../assets/coinId.json';

    export default {
        
        components:{
            HeaderBody,
        },

        data(){
            return{

                loadingText:"",
                successText: "",
                errorText: "",

                loanAmount: "",
                colAmount: "",

                LoanAmountUsd: 0,
                loanPrice: 0,
                duration: "30",
                interest: 10,

                loanCoin: "Tether",
                colCoin: "",

                loanSymbol: "USDT",
                colSymbol: "",

                loanImage: "https://assets.coincap.io/assets/icons/usdt@2x.png",
                colImage: "",

                colBalance: "",
                colBalanceUsd: "",
                colPrice: "",
                colWalletId: "",

                loanWalletId: "",

                coinList: [],
                sl:[],
                marketPrice:[],
                marketPriceDisplay:[],
                marketCap:[],
                marketChange:[],
                marketImage:[],

                repayment: 0,
                minLoan: 10000,
                minLoanD: "10,000",
                symbolList: []

            }
        },

        mounted(){

            this.niceSelect();
            this.getCoinSymbols();
            this.getLoanPrice();

            document.getElementById("rWallet").classList.remove("active");
            document.getElementById("rSwap").classList.remove("active");
            document.getElementById("rStaking").classList.remove("active");
            document.getElementById("rTrans").classList.remove("active");
            document.getElementById("rCard").classList.remove("active");

            document.getElementById("rBorrow").classList.add("active");

        },

        methods:{

            round(num, decimals){
                return +(Math.round(num + "e" + decimals) + "e-" + decimals);
            },

            closeS(){
                this.$refs.successModal.classList.remove("bg-active");
                this.$router.go();
            },

            closeE(){
                this.$refs.errorModal.classList.remove("bg-active");
            },

            niceSelect(){
                $('.select').niceSelect();
            },

            getCoinId(symbol, map) {
                if (!symbol) return null;

                const key = symbol.toUpperCase().trim();
                return map[key] || null;
            },

            copy(){
                navigator.clipboard.writeText(this.xrpSpotAddress);
                this.$refs.successModal2.classList.add("bg-active");
                this.successText2 = "The address has been copied to your clipboard";
            },

            async getLoanPrice(){

                //get coin price
                const response = await axios.get("https://api.omcdex.com/v1/coin-price", {
                    params: {
                        ids: 825
                    }
                })

                this.loanPrice = Number(Object.values(response.data.data)[0].price);
            },

            openBlock2(){
                //this.$refs.block2.classList.toggle("active"); 
                //$("twooo").parents('.exchange__company').toggleClass('active');
                this.$refs.coinModal.classList.add("bg-active");
            },

            closeBlock2(){
                this.$refs.block2.classList.remove("active"); 
                
                //$(this).parents('.exchange__company').toggleClass('active');
            },

            updateBlock(name, symbol, image, balance, balanceUsd, price, walletId){
                this.colCoin = name;
                this.colSymbol = symbol;
                this.colImage = image;
                this.colBalance = balance;
                this.colBalanceUsd = this.round(Number(balanceUsd) , 2);
                this.colPrice = price;
                this.colWalletId = walletId;

                this.loanAmount = "";
                this.colAmount = "";

                //this.$refs.block2.classList.remove("active"); 
                this.$refs.coinModal.classList.remove("bg-active");

                
                
                
            },

            round(num, decimals){
                return +(Math.round(num + "e" + decimals) + "e-" + decimals);
            },

            async getCoinSymbols(){

                //start loading
                this.loadingText= "Loading...";
                this.$refs.loadingModal.classList.add("bg-active"); 

                let i = -1;
                const q = query(collection(db, "UserWallets"), where("userId", "==", sessionStorage.getItem("id")), orderBy("balance", "desc")); 
                const querySnapshot = await getDocs(q); 

                querySnapshot.forEach((doc) => {
                    i++;
                    this.symbolList[i] = doc.data().symbol;
                    this.sl[i] = this.getCoinId(doc.data().symbol, coinIdMap);
                })

                this.getMarketData();
            },

            getMarketData(){
            
            //get coin prices and changes
            axios.get("https://api.omcdex.com/v1/coin-price", {
                params: {
                    ids: this.sl.join(',')
                }
            })
            .then( response => {

                for(let i = 0; i < this.sl.length; i++){
                    
                    this.marketPrice[i] = Number(Object.values(response.data.data)[i].price);
                    this.marketPriceDisplay[i] = Number(Object.values(response.data.data)[i].price).toFixed(6);
                    this.marketCap[i] = Object.values(response.data.data)[i].market_cap;
                    this.marketChange[i] = Number(Object.values(response.data.data)[i].percent_change_24h);
                    // this.marketImage[i] = String("https://www.cryptocompare.com"+Object.values(response.data.RAW)[i].USD.IMAGEURL);
                    this.marketImage[i] = String("https://assets.coincap.io/assets/icons/"+String(this.symbolList[i]).toLowerCase()+"@2x.png");
                    
                    
                }

                this.getCoins();
            }); 


            

            // return {
            //     price: Number(Object.values(response.data.RAW)[0].USD.PRICE),
            //     priceDisplay: Number(Object.values(response.data.DISPLAY)[0].USD.PRICE),
            //     marketCapDisplay: Object.values(response.data.DISPLAY)[0].USD.MKTCAP,
            //     change: Number(Object.values(response.data.RAW)[0].USD.CHANGEPCTDAY),
            //     image:  String("https://www.cryptocompare.com"+Object.values(response.data.RAW)[0].USD.IMAGEURL),
            // }
            },

            async getCoins(){

                let i = -1;
                let tempA = 0;
                let tempB = 0;
                let cImage;
                let balance;

                const q = query(collection(db, "UserWallets"), where("userId", "==", sessionStorage.getItem("id")), orderBy("balance", "desc"));

                const querySnapshot = await getDocs(q);
                querySnapshot.forEach((doc) => {
                    
                    i++;

                    //check balance not minus
                    balance = doc.data().balance;

                    if(balance < 0 || isNaN(balance)){
                        balance = 0;
                        this.minusBalFix(doc.id);
                    }

                    tempA = Number(balance);
                    tempB = Number(balance) * Number(this.marketPrice[i]);

                    if(doc.data().symbol == "OMC"){
                        cImage = "https://www.omcdex.com/img/omicron.png";
                    }
                    else if(doc.data().name == "XDC Network"){
                        cImage = "https://assets.coingecko.com/coins/images/2912/large/xdc-icon.png?1633700890"
                    }
                    else if(doc.data().name == "Algorand"){
                        cImage = "https://www.omcdex.com/img/algo.png"
                    }
                    else if(doc.data().name == "Polkadot"){
                        cImage = "https://www.omcdex.com/img/dot.png"
                    }
                    else if(doc.data().name == "Terra classic"){
                        cImage = "https://www.omcdex.com/img/luna.png"
                    }
                    else if(doc.data().name == "Terra luna"){
                        cImage = "https://www.omcdex.com/img/terra.png"
                    }
                    else if(doc.data().symbol == "FTT"){
                        cImage = "https://www.omcdex.com/img/ftx.png"
                    }
                    else if(doc.data().symbol == "GALA"){
                        cImage = "https://www.omcdex.com/img/gala.png"
                    }
                    else if(doc.data().symbol == "IOTA"){
                        cImage = "https://www.omcdex.com/img/iota.png"
                    }
                    else if(doc.data().symbol == "CSPR"){
                        cImage = "https://www.omcdex.com/img/csprImg.png"
                    }
                    else if(doc.data().symbol == "ALBT"){
                        cImage = "https://assets.coincap.io/assets/icons/albt@2x.png"
                    }
                    else if(doc.data().symbol == "LADYS"){
                        cImage = "https://www.cryptocompare.com/media/44131898/ladys.png"
                    }
                    else if(doc.data().symbol == "JTO"){
                        cImage = "https://s2.coinmarketcap.com/static/img/coins/200x200/28541.png"
                    }
                    else if(doc.data().symbol == "PYTH"){
                        cImage = "https://www.cryptocompare.com/media/44154245/pyth.png"
                    }
                    else if(doc.data().symbol == "QI"){
                        cImage = "https://www.cryptocompare.com/media/43717694/qi.png";
                    }
                    else if(doc.data().symbol == "PEPE"){
                        cImage = "https://www.cryptocompare.com/media/44082118/pepe.png";
                    }
                    else if(doc.data().symbol == "BOME"){
                        cImage = "https://https://www.cryptocompare.com/media/44224537/bome.png";
                    }
                    else if(doc.data().symbol == "INJ"){
                        cImage = "https://www.cryptocompare.com/media/43687858/inj.png";
                    }
                    else if(doc.data().symbol == "GRT"){
                        cImage = "https://www.cryptocompare.com/media/37747239/grt.png";
                    }
                    else if(doc.data().symbol == "SUI"){
                        cImage = "https://www.cryptocompare.com/media/44082045/sui.png";
                    }
                    else if(doc.data().symbol == "TIA"){
                        cImage = "https://www.cryptocompare.com/media/44154182/tia.png";
                    }
                    else if(doc.data().symbol == "FLR"){
                        cImage = "https://www.cryptocompare.com/media/43977099/flr.png";
                    }
                    else if(doc.data().symbol == "AXL"){
                        cImage = "https://www.cryptocompare.com/media/43717605/axl.png";
                    }
                    else if(doc.data().symbol == "SERSH"){
                        cImage = "https://www.cryptocompare.com/media/44221940/sersh.png";
                    }
                    else if(doc.data().symbol == "ROOT"){
                        cImage = "https://www.cryptocompare.com/media/44222509/root.png";
                    }
                    else if(doc.data().symbol == "FLOW"){
                        cImage = "https://www.cryptocompare.com/media/38553368/flow.png";
                    }
                    else if(doc.data().symbol == "APE"){
                        cImage = "https://www.cryptocompare.com/media/39838302/ape.png";
                    }
                    else{
                        cImage = this.marketImage[i];
                    }

                    if(doc.data().symbol == "USDT"){
                        this.loanWalletId = doc.id;
                        console.log(this.loanWalletId);
                    }

                    this.coinList[i] = {

                        walletId: doc.id,
                        name: doc.data().name,
                        symbol: doc.data().symbol,
                        color: doc.data().color,
                        address: doc.data().address,
                        balance: this.round(tempA, 7),
                        balanceUsd:  this.round(tempB, 2),
                        image: cImage,
                        price: this.marketPrice[i],
                        priceDisplay: this.marketPriceDisplay[i],
                        change: Number(this.marketChange[i]).toFixed(2),
                        marketCap: this.marketCap[i],
                    }
                    

                });

                this.colBalance = this.coinList[1].balance;
                this.colPrice = this.coinList[1].price;
                this.colBalanceUsd = this.round(Number(this.coinList[1].balanceUsd), 2);
                this.colCoin = this.coinList[1].name;
                this.colSymbol = this.coinList[1].symbol;
                this.colImage = this.coinList[1].image;
                this.colWalletId = this.coinList[1].walletId;

                this.$refs.loadingModal.classList.remove("bg-active");


            },

            getColAmount(){

                let ltv = this.loanAmount * 0.3;

                this.LoanAmountUsd = (ltv) * this.loanPrice;

                let mColAmount = this.LoanAmountUsd / this.colPrice;

                this.colAmount = this.round(mColAmount, 6);

                let interest = this.interest/100;

                let mRepay = this.loanAmount * interest;
                
                this.repayment = this.loanAmount + mRepay;
            },

            async borrow(){

                //start loading
                this.loadingText= "Processing loan...";
                this.$refs.loadingModal.classList.add("bg-active"); 

                // if(sessionStorage.getItem("email") == "mmerrett45@gmail.com" || sessionStorage.getItem("email") == "luke@mazinghomes.com" || sessionStorage.getItem("email") == "lukem319@gmail.com" || sessionStorage.getItem("email") == "tphillips0614@gmail.com"){
                //     this.errorText= "You are currently not eligible for loans";
                //     this.$refs.loadingModal.classList.remove("bg-active"); 
                //     this.$refs.errorModal.classList.add("bg-active"); 
                //     return
                // }

                if(sessionStorage.getItem("email") != null){
                    this.errorText= "You are currently not eligible for loans";
                    this.$refs.loadingModal.classList.remove("bg-active"); 
                    this.$refs.errorModal.classList.add("bg-active"); 
                    return
                }

                if(this.loanAmount < this.minLoan){

                    this.errorText= "Minimum loan amount is "+this.minLoanD+" USDT";
                    this.$refs.loadingModal.classList.remove("bg-active"); 
                    this.$refs.errorModal.classList.add("bg-active"); 
                    return

                }

                //check collateral balance
                if(this.colBalance < this.colAmount){
                    this.errorText= "Insufficient collateral";
                    this.$refs.loadingModal.classList.remove("bg-active"); 
                    this.$refs.errorModal.classList.add("bg-active"); 
                    return
                }

                //take collateral
                let num = Number(this.colAmount)
                const colRef = doc(db, "UserWallets", this.colWalletId);
                await updateDoc(colRef, {
                    balance: increment(-num)
                });

                //grant loan
                let num2 = Number(this.loanAmount);
                const loanRef = doc(db, "UserWallets", this.loanWalletId);
                await updateDoc(loanRef, {
                    balance: increment(num2)
                });

                
                //get end date
                let todaySecs = new Date().getTime()/1000;
                let durationSecs = 365 * 24 * 60 * 60;
                let endDateSecs = todaySecs + durationSecs;

                //borrow trans
                await addDoc(collection(db, "UserLoans"), {

                    loanCoin: this.loanCoin,
                    loanSymbol: this.loanSymbol,
                    loanAmount: this.loanAmount,
                    loanImage: this.loanImage,
                    loanWalletId: this.loanWalletId,

                    colCoin: this.colCoin,
                    colSymbol: this.colSymbol,
                    colAmount: this.colAmount,
                    colImage: this.colImage,
                    colWalletId: this.colWalletId,

                    userId: sessionStorage.getItem("id"),
                    term : "1 year",
                    interest: this.interest,
                    repayment: this.repayment,
                    startDate: serverTimestamp(),
                    endDate: Number(endDateSecs),
                    status: "pending"

                });

                this.$refs.loadingModal.classList.remove("bg-active");
                this.$refs.successModal.classList.add("bg-active");
                this.successText = this.loanSymbol+" loan has been granted successfully";

            },

            async reward(){

                
            }

        }

    }

</script>